export const calSinx = (x: number) => {
  if (x < 0 || x > 1) {
    return 0;
  }
  return Math.sin((x * Math.PI) / 2);
};

export const scrollElement = (
  element: HTMLElement,
  to: number,
  steps = 500,
) => {
  return new Promise((resolve) => {
    let scrolled = 0;
    const scrollStep = (to - scrolled) / steps;
    const interval = setInterval(() => {
      if (scrolled < to) {
        scrolled += scrollStep;
        element.scrollLeft = scrolled;
      } else {
        clearInterval(interval);
        resolve(null);
      }
    }, 1);
  });
  //   element.scrollBy({
  //     left: to,
  //     behavior: 'smooth',
  //   } as ScrollToOptions);
};

export const PHASE1_ANIMATION_DURATION = 4000;

export const PHASE2_ANIMATION_DURATION = 500;

export const NEAR_MISS_GAP = 16;
